import { render, staticRenderFns } from "./TopCustomerReport.vue?vue&type=template&id=c45ff41c&"
import script from "./TopCustomerReport.vue?vue&type=script&lang=js&"
export * from "./TopCustomerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports